
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/usage-limit-help",
      function () {
        return require("private-next-pages/usage-limit-help/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/usage-limit-help"])
      });
    }
  